const layoutStyles = {
    divider: (theme) => ({
        marginBottom: theme.spacing(3.75),
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    }),
    searchFiltersContainer: (theme) => ({
        backgroundColor: theme.palette.background.default,
        textAlign: 'left',
        '@media (max-width: 930px)': {
            padding: theme.spacing(0, 2),
        },
    }),
};
export const mainLayoutStyles = {
    searchBarContainer: (theme) => ({
        margin: 'auto',
        padding: theme.spacing(6.875, 3.75, 0),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0, 1.875),
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(0, 2),
        },
        [theme.breakpoints.up('lg')]: {
            padding: theme.spacing(0),
        },
    }),
    searchBar: (theme) => ({
        [theme.breakpoints.up('md')]: {
            borderBottom: `1px solid ${theme.palette.secondary.contrastText}`,
            maxWidth: 1104,
            margin: '0 auto',
        },
    }),
    toggleButton: (theme) => ({
        position: 'fixed',
        right: 0,
        top: '50%',
        marginTop: theme.spacing(-3),
        minWidth: 0,
        width: theme.spacing(6.25),
        fontSize: theme.spacing(2),
        fontWeight: 'bold',
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.background.default,
        display: 'block',
        padding: theme.spacing(1.25, 0),
        borderRadius: theme.spacing(0.5, 0, 0, 0.5),
        lineHeight: '22px',
        '&:hover': {
            backgroundColor: theme.palette.primary.contrastText,
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
        span: {
            margin: 0,
            marginTop: theme.spacing(1.25),
        },
    }),
    toggleButtonIcon: (theme) => ({
        '& .MuiButton-endIcon': {
            marginRight: 0,
            marginLeft: 0,
            marginTop: theme.spacing(1.25),
        },
    }),
    fullWidthContent: (theme) => ({
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginTop: '0 !important',
        },
    }),
};
export default layoutStyles;
